module.exports = __webpack_public_path__ + "img/inPool.73d3562d.png";